'use strict';

// Website USD plan display amounts. Store purchases use their live localized
// catalogs; Model/CreditPack quotes and payment-provider charges stay separate.
module.exports = Object.freeze({
  free: Object.freeze({ price: '$0' }),
  plus: Object.freeze({
    weeklyPrice: '6.99',
    monthlyPrice: '20.00',
    annualPrice: '200.00',
    annualMonthlyPrice: '16.67',
    annualWeeklyPrice: '3.85',
    bitcoinAnnualPrice: '180',
  }),
  plusPremium: Object.freeze({
    monthlyPrice: '99.00',
    annualPrice: '999.00',
    annualMonthlyPrice: '83.25',
    bitcoinAnnualPrice: '899',
  }),
});
